import React from 'react'

function SelectorItem( { lastItem, children } ) {
	return (
		<div className="stlst-control-main--selector-item" data-last={lastItem}>
			<strong>{ children[0] }</strong><span>{ children.substring(1, children.length) }</span>
			{/* <svg aria-hidden="true" role="img" focusable="false" className="dashicon arrow-right" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M8 6l6 4.03L8 14V6z"></path></svg> */}
		</div>
	);
}

export default SelectorItem;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/css-selector/selector-item.jsx